import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  FaUserCircle, FaBell, FaSignOutAlt, FaMoneyBillWave, FaExchangeAlt, FaCreditCard, FaFileAlt, FaHistory,
  FaMobile, FaShieldAlt, FaBusinessTime, FaUsers, FaCoins, FaCheckCircle, FaBus, FaUserPlus,
  FaPlusCircle, FaMinusCircle, FaClock, FaChartBar, FaFingerprint, FaIdCard
} from 'react-icons/fa';

import WalletToWalletTransferModal from '../../components/WalletToWalletTransferModal';
import WalletStatementModal from '../../components/WalletStatementModal';
import MobileRechargeForm from '../../components/MobileRechargeForm';
import SecureBillPaymentModal from '../../components/SecureBillPaymentModal';
import SecurePPIDMTModal from '../../components/SecurePPIDMTModal';
import SecureFinoDMTModal from '../../components/SecureFinoDMTModal';
import SecurePayTMDMTModal from '../../components/SecurePayTMDMTModal';
import ComprehensiveDMTModal from '../../components/ComprehensiveDMTModal';
import DMTBank2Modal from '../../components/DMTBank2Modal';
import DMTBank4Modal from '../../components/DMTBank4Modal';
import DMTCASAModal from '../../components/DMTCASAModal';
import DMTBank6Modal from '../../components/DMTBank6Modal';
import AEPSOnboardingModal from '../../components/AEPSOnboardingModal';
import AEPSModal from '../../components/AEPSModal';
import WalletMoneyModal from '../../components/WalletMoneyModal';
import CreditCardPaymentModal from '../../components/CreditCardPaymentModal';
import InsuranceModal from '../../components/InsuranceModal';
import CMSModal from '../../components/CMSModal';
import FinoDMTModal from '../../components/FinoDMTModal';
import MicroATMModal from '../../components/MicroATMModal';
import AEPSCashDepositModal from '../../components/AEPSCashDepositModal';
import AccountOpeningModal from '../../components/AccountOpeningModal';
import VerificationsModal from '../../components/VerificationsModal';
import BillPaymentModal from '../../components/BillPaymentModal';
import HLRModal from '../../components/HLRModal';
// import BusBookingModal from '../../components/BusBookingModal'; // Removed
import KycUploadModal from '../../components/KycUploadModal';
import { walletAPI } from '../../services/api';
import { useAuth } from '../../contexts/AuthContext';
import useInactivityTimer from '../../hooks/useInactivityTimer';
import InactivityTimer from '../../components/InactivityTimer';
import InactivityWarning from '../../components/InactivityWarning';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

const sidebarItems = [
  'Dashboard',
  'Business Summary',
  'Transactions',
  'Refund Pending',
  'Money Request',
  'Investments',
  'Charges & Rates',
  'Complaints',
  'Configuration',
  'Previous Reports',
  'Settings',
];

const actionTiles = [
  // USER-ONLY SERVICES - These services are restricted to users and not available to distributors
  // Money Transfer Services
  { label: 'DMT Service', icon: <FaExchangeAlt className="mx-auto text-green-600 text-2xl" />, category: 'transfer', highlight: true },
  { label: 'DMT Bank2', icon: <FaExchangeAlt className="mx-auto text-orange-600 text-2xl" />, category: 'transfer', highlight: true },
          { label: 'DMT Bank4', icon: <FaExchangeAlt className="mx-auto text-red-600 text-2xl" />, category: 'transfer', highlight: true },
          { label: 'DMT CASA', icon: <FaExchangeAlt className="mx-auto text-teal-600 text-2xl" />, category: 'transfer', highlight: true },
          { label: 'DMT Bank6', icon: <FaExchangeAlt className="mx-auto text-cyan-600 text-2xl" />, category: 'transfer', highlight: true },
          { label: 'AEPS Onboarding', icon: <FaIdCard className="mx-auto text-indigo-600 text-2xl" />, category: 'onboarding', highlight: true },
  { label: 'AEPS', icon: <FaFingerprint className="mx-auto text-purple-600 text-2xl" />, category: 'aeps', highlight: true },
  { label: 'Wallet Money', icon: <FaMoneyBillWave className="mx-auto text-pink-600 text-2xl" />, category: 'transfer', highlight: true },
  { label: 'PPI DMT', icon: <FaExchangeAlt className="mx-auto text-blue-600 text-2xl" />, category: 'transfer' },
  { label: 'Fino DMT', icon: <FaExchangeAlt className="mx-auto text-purple-600 text-2xl" />, category: 'transfer' },
  { label: 'PayTM DMT', icon: <FaExchangeAlt className="mx-auto text-indigo-600 text-2xl" />, category: 'transfer' },

  // Banking Services
  { label: 'Micro ATM', icon: <FaCreditCard className="mx-auto text-teal-600 text-2xl" />, category: 'banking' },
  { label: 'AEPS Cash Deposit', icon: <FaPlusCircle className="mx-auto text-emerald-600 text-2xl" />, category: 'banking' },
  { label: 'Account Opening', icon: <FaUserPlus className="mx-auto text-cyan-600 text-2xl" />, category: 'banking' },

  // Payment Services
  { label: 'Recharge Bill & DTH', icon: <FaMobile className="mx-auto text-orange-600 text-2xl" />, category: 'payments' },
  { label: 'HLR Services', icon: <FaMobile className="mx-auto text-indigo-600 text-2xl" />, category: 'utility', highlight: true },
  { label: 'Credit Card Payment', icon: <FaCreditCard className="mx-auto text-red-600 text-2xl" />, category: 'payments' },

  // Financial Services
  { label: 'Insurance', icon: <FaShieldAlt className="mx-auto text-blue-700 text-2xl" />, category: 'financial' },
  { label: 'CMS', icon: <FaBusinessTime className="mx-auto text-gray-600 text-2xl" />, category: 'financial' },
  { label: 'Leads Generation', icon: <FaUsers className="mx-auto text-pink-600 text-2xl" />, category: 'financial' },

  // Digital Services
  { label: 'Digital Gold', icon: <FaCoins className="mx-auto text-yellow-500 text-2xl" />, category: 'digital' },
  { label: 'Verifications', icon: <FaCheckCircle className="mx-auto text-green-700 text-2xl" />, category: 'digital' },
  { label: 'KYC Upload', icon: <FaIdCard className="mx-auto text-indigo-600 text-2xl" />, category: 'digital' },

  // Travel Services - Removed
  // { label: 'Bus Booking', icon: <FaBus className="mx-auto text-blue-500 text-2xl" />, category: 'travel' },

  // Management Options
  { label: 'Wallet To Wallet', icon: <FaExchangeAlt className="mx-auto text-purple-600 text-2xl" />, category: 'management' },

  { label: 'Virtual Transactions', icon: <FaCreditCard className="mx-auto text-blue-600 text-2xl" />, category: 'management' }
];

const quickStats = [
  { label: 'Fund', value: 0 },
  { label: 'Money Transfer', value: 0 },
  { label: 'Utilities Paid', value: 0 },
  { label: 'AEPS/MATM', value: 0 },
  { label: 'Credit Card', value: 0 },
  { label: 'Aadhar Pay', value: 0 },
];
const inProgressStats = [
  { label: 'Money Transfer', value: 0 },
  { label: 'Recharges/Utility', value: 0 },
  { label: 'Credit Card', value: 0 },
  { label: 'AEPS/MATM', value: 0 },
  { label: 'Aadhar Pay', value: 0 },
];
const refundStats = [
  { label: 'Money Transfer', value: 0 },
  { label: 'Utilities', value: 0 },
  { label: 'Credit Card', value: 0 },
];

export default function UserDashboard() {
  const { logout, user } = useAuth();
  const navigate = useNavigate();
  const year = new Date().getFullYear();

  const [showWalletToWalletModal, setShowWalletToWalletModal] = useState(false);
  const [showWalletStatementModal, setShowWalletStatementModal] = useState(false);
  const [availableBalance, setAvailableBalance] = useState(0);
  const [settingsImages, setSettingsImages] = useState({ logo: '', banner: '' });
  const [currentTime, setCurrentTime] = useState(new Date());

  // Inactivity timer
  const {
    timeLeft,
    showWarning,
    formatTime,
    handleContinue,
    handleLogout,
    setIsActive
  } = useInactivityTimer(logout, 240000); // 4 minutes
  
  // Service Modal States
  const [showMobileRechargeModal, setShowMobileRechargeModal] = useState(false);
  const [showBillPaymentModal, setShowBillPaymentModal] = useState(false);
  const [showHLRModal, setShowHLRModal] = useState(false);
  const [showCreditCardModal, setShowCreditCardModal] = useState(false);
  const [showInsuranceModal, setShowInsuranceModal] = useState(false);
  const [showCMSModal, setShowCMSModal] = useState(false);
  const [showComprehensiveDMTModal, setShowComprehensiveDMTModal] = useState(false);
  const [showDMTBank2Modal, setShowDMTBank2Modal] = useState(false);
  const [showDMTBank4Modal, setShowDMTBank4Modal] = useState(false);
  const [showDMTCASAModal, setShowDMTCASAModal] = useState(false);
  const [showDMTBank6Modal, setShowDMTBank6Modal] = useState(false);
  const [showAEPSOnboardingModal, setShowAEPSOnboardingModal] = useState(false);
  const [showAEPSModal, setShowAEPSModal] = useState(false);
  const [showWalletMoneyModal, setShowWalletMoneyModal] = useState(false);
  const [showPPIDMTModal, setShowPPIDMTModal] = useState(false);
  const [showFinoDMTModal, setShowFinoDMTModal] = useState(false);
  const [showPayTMDMTModal, setShowPayTMDMTModal] = useState(false);
  const [showMicroATMModal, setShowMicroATMModal] = useState(false);
  const [showAEPSCashDepositModal, setShowAEPSCashDepositModal] = useState(false);
  const [showAccountOpeningModal, setShowAccountOpeningModal] = useState(false);
  const [showVerificationsModal, setShowVerificationsModal] = useState(false);
  // const [showBusBookingModal, setShowBusBookingModal] = useState(false); // Removed
  const [showKycUploadModal, setShowKycUploadModal] = useState(false);
  const [showMobileMenu, setShowMobileMenu] = useState(false);

  const updateBalance = (newBalance) => {
    setAvailableBalance(newBalance);
  };

  // Function to refresh balance from API
  const refreshBalance = async () => {
    try {
      const response = await walletAPI.getUserWallet();
      if (response.data && response.data.balance !== undefined) {
        setAvailableBalance(response.data.balance);
      }
    } catch (error) {
      console.error('Error refreshing balance:', error);
    }
  };

  const handleActionTileClick = (tileLabel) => {
    switch (tileLabel) {
      // Money Transfer Services
      case 'DMT Service':
        setShowComprehensiveDMTModal(true);
        break;
      case 'DMT Bank2':
        setShowDMTBank2Modal(true);
        break;
        case 'DMT Bank4':
          setShowDMTBank4Modal(true);
          break;
        case 'DMT CASA':
          setShowDMTCASAModal(true);
          break;
        case 'DMT Bank6':
          setShowDMTBank6Modal(true);
          break;
        case 'AEPS Onboarding':
          setShowAEPSOnboardingModal(true);
          break;
        case 'AEPS':
          setShowAEPSModal(true);
          break;
      case 'Wallet Money':
        setShowWalletMoneyModal(true);
        break;
      case 'PPI DMT':
        setShowPPIDMTModal(true);
        break;
      case 'Fino DMT':
        setShowFinoDMTModal(true);
        break;
      case 'PayTM DMT':
        setShowPayTMDMTModal(true);
        break;
      
      // Banking Services
      case 'AEPS':
        setShowAEPSModal(true);
        break;
      case 'Micro ATM':
        setShowMicroATMModal(true);
        break;
      case 'AEPS Cash Deposit':
        setShowAEPSCashDepositModal(true);
        break;
      case 'Account Opening':
        setShowAccountOpeningModal(true);
        break;
      
      // Payment Services
      case 'Recharge Bill & DTH':
        navigate('/services/recharge');
        break;
      case 'HLR Services':
        setShowHLRModal(true);
        break;
      case 'Credit Card Payment':
        setShowCreditCardModal(true);
        break;
      
      // Financial Services
      case 'Insurance':
        setShowInsuranceModal(true);
        break;
      case 'CMS':
        setShowCMSModal(true);
        break;
      case 'Leads Generation':
        alert('Leads Generation service - Customer lead generation');
        break;
      
      // Digital Services
      case 'Digital Gold':
        alert('Digital Gold service - Buy and sell digital gold');
        break;
      case 'Verifications':
        setShowVerificationsModal(true);
        break;
      case 'KYC Upload':
        setShowKycUploadModal(true);
        break;
      
      // Travel Services - Removed
      // case 'Bus Booking':
      //   setShowBusBookingModal(true);
      //   break;
      
      // Management Options
      case 'Wallet To Wallet':
        setShowWalletToWalletModal(true);
        break;
      case 'Add Fund Request':
        // Add Money functionality removed
        break;
      case 'Virtual Transactions':
        alert('Virtual Transactions service - Virtual account transactions');
        break;
      
      default:
        alert(`${tileLabel} service coming soon!`);
        break;
    }
  };

  useEffect(() => {
    const fetchBalance = async () => {
      try {
        const response = await walletAPI.getUserWallet();
        console.log('Balance response:', response.data);
        // The existing route returns { balance: number }
        if (response.data && response.data.balance !== undefined) {
          setAvailableBalance(response.data.balance);
        } else {
          setAvailableBalance(0);
        }
      } catch (error) {
        console.error('Error fetching balance:', error);
        setAvailableBalance(0);
      }
    };

    fetchBalance();
  }, []);

  useEffect(() => {
    const fetchSettingsImages = async () => {
      try {
        const res = await walletAPI.getSettingsImages();
        setSettingsImages(res.data);
      } catch (e) {}
    };
    fetchSettingsImages();
  }, []);

  // Update time every minute to refresh greeting
  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentTime(new Date());
    }, 60000); // Update every minute
    return () => clearInterval(timer);
  }, []);

  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://127.0.0.1:8000';
  const demoBanners = [
    {
      title: 'Secure PaySprint APIs',
      subtitle: 'All services now mapped with live encryption & logging.',
      gradient: 'from-indigo-600 via-blue-500 to-cyan-400',
    },
    {
      title: 'Uptime Monitoring',
      subtitle: '24x7 monitoring & alerts for AEPS, DMT, CMS, Insurance.',
      gradient: 'from-purple-600 via-fuchsia-500 to-pink-400',
    },
    {
      title: 'Wallet Automation',
      subtitle: 'Idempotency + auto reconciliation keeps balance accurate.',
      gradient: 'from-emerald-600 via-green-500 to-lime-400',
    },
  ];
  const getImageUrl = (url) => {
    if (!url) return '';
    if (url.startsWith('http')) return url;
    return `${API_BASE_URL}${url}`;
  };

  // Helper function to get logo URL with fallback
  const getLogoUrl = () => {
    // For now, always use the fallback logo to prevent flickering
    // TODO: Debug API logo loading issue separately
    return '/bt-india-logo.jpeg';
  };

    // Helper function to get time-based greeting
  const getTimeBasedGreeting = () => {
    const hour = currentTime.getHours();
    // Removed console.log to prevent repeated logging

    if (hour < 12) {
      return 'Good Morning';
    } else if (hour < 17) {
      return 'Good Afternoon';
    } else {
      return 'Good Evening';
    }
  };

  return (
    <div className="min-h-screen h-screen flex flex-col bg-gray-100">
      {/* Gradient Header */}
      <header className="bg-gradient-to-r from-indigo-900 via-blue-900 to-blue-700 text-white px-4 sm:px-6 py-3">
        {/* Mobile Header */}
        <div className="flex items-center justify-between lg:hidden">
          <div className="flex items-center gap-2">
            <img src={getLogoUrl()} alt="BT India Logo" className="h-8 w-auto" />
            <h1 className="text-lg font-bold">User Dashboard</h1>
          </div>
          <div className="flex items-center gap-2">
            <FaBell className="text-lg" />
            <button onClick={logout} className="px-3 py-1 bg-blue-800 hover:bg-blue-900 rounded text-white text-sm">Logout</button>
          </div>
        </div>

        {/* Desktop Header */}
        <div className="hidden lg:flex items-center justify-between">
          <div className="flex items-center gap-4">
            <img src={getLogoUrl()} alt="BT India Logo" className="h-16 w-auto" />
            <div>
              <h1 className="text-2xl font-bold tracking-wide">User Dashboard</h1>
            </div>
            <InactivityTimer 
              timeLeft={timeLeft} 
              formatTime={formatTime} 
              isActive={!!user} 
            />
          </div>
          <div className="flex-1 flex justify-center space-x-8 text-xs md:text-base">
            <div className="flex flex-col items-center"><span className="text-blue-200">Opening Balance</span><span className="text-blue-400">0</span></div>
            <div className="flex flex-col items-center">
              <span className="text-green-200">Available Balance</span>
              <span className="text-green-400">{availableBalance}</span>
              <button 
                className="text-xs text-blue-300 hover:text-blue-100 underline mt-1"
                onClick={() => setShowWalletStatementModal(true)}
              >
                View Statement
              </button>
            </div>
            <div className="flex flex-col items-center"><span className="text-red-200">Credit Balance Hold Balance</span><span className="text-red-400">0</span></div>
            {/* Wallet Buttons */}
            <div className="flex space-x-2 ml-4">
              <button
                className="bg-yellow-400 hover:bg-yellow-500 text-blue-900 font-semibold px-4 py-2 rounded shadow transition"
                onClick={() => navigate('/wallet/update-payment')}
              >
                Update Payment
              </button>
              <button
                className="bg-green-400 hover:bg-green-500 text-blue-900 font-semibold px-4 py-2 rounded shadow transition"
                onClick={() => navigate('/wallet/my-requests')}
              >
                My Requests
              </button>
            </div>
          </div>
          <div className="flex items-center space-x-4">
            <FaBell className="text-xl" />
            <span className="font-semibold">{user?.email || user?.username || 'User'}</span>
            <FaUserCircle className="text-2xl" />
            <button
              onClick={logout}
              className="ml-4 px-4 py-2 bg-blue-800 hover:bg-blue-900 rounded text-white font-semibold text-sm shadow flex items-center"
            >
              <FaSignOutAlt className="mr-2" />
              Logout
            </button>
          </div>
        </div>

        {/* Mobile Balance Bar */}
        <div className="lg:hidden mt-3 bg-blue-800 rounded-lg p-3">
          <div className="grid grid-cols-2 gap-2 text-xs">
            <div className="flex flex-col items-center"><span className="text-blue-200">Available</span><span className="text-green-400 font-bold">{availableBalance}</span></div>
            <div className="flex flex-col items-center"><span className="text-blue-200">Credit</span><span className="text-red-400 font-bold">0</span></div>
          </div>
          <div className="space-y-2 mt-2">
            <button
              className="w-full bg-yellow-400 hover:bg-yellow-500 text-blue-900 font-semibold px-4 py-2 rounded shadow transition"
              onClick={() => navigate('/wallet/update-payment')}
            >
              Update Payment
            </button>
            <button
              className="w-full bg-green-400 hover:bg-green-500 text-blue-900 font-semibold px-4 py-2 rounded shadow transition"
              onClick={() => navigate('/wallet/my-requests')}
            >
              My Requests
            </button>
          </div>
        </div>
      </header>

      <div className="flex flex-1 min-h-0">
        {/* Mobile Menu Button */}
        <button 
          className="lg:hidden fixed top-4 left-4 z-50 bg-blue-900 text-white p-2 rounded-lg shadow-lg"
          onClick={() => setShowMobileMenu(!showMobileMenu)}
        >
          <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
          </svg>
        </button>

        {/* Mobile Menu Overlay */}
        {showMobileMenu && (
          <div 
            className="lg:hidden fixed inset-0 bg-black bg-opacity-50 z-40"
            onClick={() => setShowMobileMenu(false)}
          />
        )}

        {/* Sidebar */}
        <aside className={`w-64 bg-gradient-to-b from-indigo-900 to-blue-900 text-white flex flex-col justify-between p-4 min-h-0 fixed lg:relative inset-y-0 left-0 z-50 transform transition-transform duration-300 ease-in-out ${showMobileMenu ? 'translate-x-0' : '-translate-x-full lg:translate-x-0'}`}>
          {/* Close button for mobile */}
          <button
            onClick={() => setShowMobileMenu(false)}
            className="lg:hidden absolute top-4 right-4 p-2 text-white hover:bg-blue-800 rounded"
          >
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
          <div>
            <ul className="space-y-2 text-sm">
              {sidebarItems.map((item, idx) => (
                <li 
                  key={idx} 
                  className="p-2 rounded hover:bg-blue-800 cursor-pointer flex items-center"
                  onClick={undefined}
                >
                  <span className="ml-2">{item}</span>
                </li>
              ))}
            </ul>
            <div className="mt-8 text-center">
              <div className="text-pink-400 font-bold text-lg mb-2">Let's CONNECT</div>
              <div className="bg-blue-800 rounded-lg p-3 mb-2">
                <div className="flex items-center justify-center mb-2">
                  <FaUserCircle className="text-3xl mr-2" />
                  <div>
                    <div className="font-semibold">{user.name}</div>
                    <div className="text-xs">Retailer - {user.code}</div>
                  </div>
                </div>
                <div className="text-xs">Phone: {user.phone}</div>
              </div>
              <div className="bg-blue-800 rounded-lg p-3 text-xs">
                <div className="font-semibold mb-1">QUICK SUPPORT :</div>
                <div className="mb-1">Phone: 011-40004000</div>
                <div className="mb-1">Email: info@spayindia.com</div>
              </div>
            </div>
          </div>
          <footer className="text-center text-xs text-blue-200 mt-8">© {year} Spay India. All rights reserved.</footer>
        </aside>

        {/* Main Content */}
        <main className="flex-1 p-2 sm:p-4 min-h-0 overflow-auto bg-gray-50 lg:ml-0">
          {/* Notification Bar */}
          <div className="bg-white rounded shadow flex items-center px-4 py-2 mb-4">
            <FaBell className="text-red-500 mr-2" />
            <span className="text-red-600 font-semibold">You have 0 New Notifications !</span>
          </div>

          {/* Greeting */}
          <div className="text-xl font-semibold text-blue-900 mb-4">Hey ! {getTimeBasedGreeting()} , Hope You are doing Good !!!</div>

          {/* Action Tiles */}
          <div className="bg-gradient-to-r from-indigo-900 to-blue-900 rounded-t-xl p-4 mb-4">
            <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 xl:grid-cols-8 gap-2 sm:gap-3">
              {actionTiles.map((tile, idx) => (
                <div
                  key={idx}
                  className={`rounded-lg shadow p-3 flex flex-col items-center hover:bg-blue-50 cursor-pointer transition min-h-[100px] ${
                    tile.highlight ? 'bg-green-100 border-2 border-green-500' : 'bg-white'
                  }`}
                  onClick={() => handleActionTileClick(tile.label)}
                >
                  {tile.icon}
                  <span className={`mt-2 text-xs text-center font-medium ${
                    tile.highlight ? 'text-green-800 font-bold' : 'text-gray-700'
                  }`}>{tile.label}</span>
                </div>
              ))}
            </div>
          </div>

          {/* Quick Stats & Transaction Panels */}
          <div className="flex flex-col lg:flex-row gap-4">
            {/* Left: Fund/Service Usage, InProgress, Refund Pending */}
            <div className="flex-1 grid grid-cols-1 md:grid-cols-2 gap-4">
              {/* Fund and Service Usage */}
              <div className="bg-white rounded-xl shadow p-4">
                <h3 className="font-semibold mb-2 text-blue-900">Fund and Service Usage</h3>
                <div className="grid grid-cols-2 gap-2 text-xs">
                  {quickStats.map((stat, idx) => (
                    <div key={idx} className="bg-blue-50 rounded p-2 flex flex-col items-center">
                      <span className="font-bold text-lg text-blue-700">{stat.value}</span>
                      <span className="text-gray-600">{stat.label}</span>
                    </div>
                  ))}
                </div>
              </div>
              {/* InProgress Transactions */}
              <div className="bg-white rounded-xl shadow p-4">
                <h3 className="font-semibold mb-2 text-blue-900">InProgress Transactions</h3>
                <div className="grid grid-cols-2 gap-2 text-xs">
                  {inProgressStats.map((stat, idx) => (
                    <div key={idx} className="bg-purple-50 rounded p-2 flex flex-col items-center">
                      <span className="font-bold text-lg text-purple-700">{stat.value}</span>
                      <span className="text-gray-600">{stat.label}</span>
                    </div>
                  ))}
                </div>
              </div>
              {/* Refund Pending Transactions */}
              <div className="bg-white rounded-xl shadow p-4 md:col-span-2">
                <h3 className="font-semibold mb-2 text-blue-900">Refund Pending Transactions</h3>
                <div className="grid grid-cols-3 gap-2 text-xs">
                  {refundStats.map((stat, idx) => (
                    <div key={idx} className="bg-red-50 rounded p-2 flex flex-col items-center">
                      <span className="font-bold text-lg text-red-700">{stat.value}</span>
                      <span className="text-gray-600">{stat.label}</span>
                    </div>
                  ))}
                </div>
              </div>
            </div>
            {/* Right: Banners/Ads (optional, as in screenshot) */}
            <div className="w-full lg:w-1/3 flex flex-col gap-4">
              <div className="bg-white rounded-xl shadow p-4 flex flex-col items-center justify-center h-auto mt-8">
                {settingsImages.banner && (
                  <div className="w-full mb-6">
                    <img src={getImageUrl(settingsImages.banner)} alt="Banner" className="h-32 w-full object-contain" />
                  </div>
                )}
                <div className="w-full">
                  <Slider dots={true} infinite={true} speed={500} slidesToShow={1} slidesToScroll={1} autoplay={true} autoplaySpeed={3000}>
                    {demoBanners.map((banner, idx) => (
                      <div key={idx} className="px-1">
                        <div className={`h-32 w-full rounded-xl bg-gradient-to-r ${banner.gradient} flex flex-col justify-center px-4 text-white shadow-inner`}>
                          <p className="text-lg font-semibold">{banner.title}</p>
                          <p className="text-sm opacity-90">{banner.subtitle}</p>
                        </div>
                      </div>
                    ))}
                  </Slider>
              </div>
              </div>
            </div>
          </div>
        </main>
      </div>


      <WalletToWalletTransferModal 
        show={showWalletToWalletModal} 
        onHide={() => setShowWalletToWalletModal(false)} 
        onSuccess={null}
        onBalanceUpdate={updateBalance}
      />

      <WalletStatementModal
        show={showWalletStatementModal}
        onHide={() => setShowWalletStatementModal(false)}
      />

      {/* Service Modals */}
      
      {/* Legacy Mobile Recharge (kept for backward compatibility) */}
      <MobileRechargeForm
        show={showMobileRechargeModal}
        onHide={() => setShowMobileRechargeModal(false)}
        onSuccess={(data) => {
          console.log('Recharge successful:', data);
          // Update balance if provided, otherwise refresh from API
          if (data.new_balance !== undefined) {
            setAvailableBalance(data.new_balance);
          } else {
            refreshBalance();
          }
          alert(`Recharge successful! Transaction ID: ${data.transaction_id}`);
        }}
      />

      <SecureBillPaymentModal
        show={showBillPaymentModal}
        onHide={() => setShowBillPaymentModal(false)}
        onSuccess={(data) => {
          console.log('Bill payment successful:', data);
          // Refresh balance after successful transaction
          if (data.new_balance !== undefined) {
            setAvailableBalance(data.new_balance);
          } else {
            refreshBalance();
          }
          alert(`Bill payment successful! Transaction ID: ${data.transaction_id}`);
        }}
      />

      <CreditCardPaymentModal
        show={showCreditCardModal}
        onHide={() => setShowCreditCardModal(false)}
        onSuccess={(data) => {
          console.log('Credit card payment successful:', data);
          // Refresh balance after successful transaction
          refreshBalance();
          alert(`Credit card payment successful! Transaction ID: ${data.transactionId}`);
        }}
      />

      <InsuranceModal
        show={showInsuranceModal}
        onHide={() => setShowInsuranceModal(false)}
        onSuccess={(data) => {
          console.log('Insurance purchase successful:', data);
          // Refresh balance after successful transaction
          refreshBalance();
          alert(`Insurance policy purchased! Policy Number: ${data.policyNumber}`);
        }}
      />

      <CMSModal
        show={showCMSModal}
        onHide={() => setShowCMSModal(false)}
        onSuccess={(data) => {
          console.log('CMS service activated:', data);
          alert(`CMS service activated! Service ID: ${data.serviceId}`);
        }}
      />

      <SecurePPIDMTModal
        show={showPPIDMTModal}
        onHide={() => setShowPPIDMTModal(false)}
        onSuccess={(data) => {
          console.log('PPI DMT transfer successful:', data);
          // Refresh balance after successful transaction
          refreshBalance();
          alert(`PPI DMT transfer successful! Transaction ID: ${data.transaction_id}`);
        }}
      />

      <SecureFinoDMTModal
        show={showFinoDMTModal}
        onHide={() => setShowFinoDMTModal(false)}
        onSuccess={(data) => {
          console.log('Fino DMT transfer successful:', data);
          // Refresh balance after successful transaction
          refreshBalance();
          alert(`Fino DMT transfer successful! Transaction ID: ${data.transaction_id}`);
        }}
      />

      <SecurePayTMDMTModal
        show={showPayTMDMTModal}
        onHide={() => setShowPayTMDMTModal(false)}
        onSuccess={(data) => {
          console.log('PayTM DMT transfer successful:', data);
          // Refresh balance after successful transaction
          refreshBalance();
          alert(`PayTM DMT transfer successful! Transaction ID: ${data.transaction_id}`);
        }}
      />

      <ComprehensiveDMTModal
        show={showComprehensiveDMTModal}
        onHide={() => setShowComprehensiveDMTModal(false)}
        onSuccess={(data) => {
          console.log('DMT transaction successful:', data);
          // Refresh balance after successful transaction
          refreshBalance();
          alert(`DMT transaction successful! Transaction ID: ${data.transaction_id}`);
        }}
      />

      <DMTBank2Modal
        show={showDMTBank2Modal}
        onHide={() => setShowDMTBank2Modal(false)}
        onSuccess={(data) => {
          console.log('DMT Bank2 transaction successful:', data);
          // Refresh balance after successful transaction
          refreshBalance();
          alert(`DMT Bank2 transaction successful! Transaction ID: ${data.transaction_id}`);
        }}
      />

        <DMTBank4Modal
          show={showDMTBank4Modal}
          onHide={() => setShowDMTBank4Modal(false)}
          onSuccess={(data) => {
            console.log('DMT Bank4 transaction successful:', data);
            // Refresh balance after successful transaction
            refreshBalance();
            alert(`DMT Bank4 transaction successful! Reference ID: ${data.reference_id}`);
          }}
        />

        <DMTCASAModal
          show={showDMTCASAModal}
          onHide={() => setShowDMTCASAModal(false)}
          onSuccess={(data) => {
            console.log('DMT CASA transaction successful:', data);
            // Refresh balance after successful transaction
            refreshBalance();
            alert(`DMT CASA transaction successful! Reference ID: ${data.reference_id}`);
          }}
        />

        <DMTBank6Modal
          show={showDMTBank6Modal}
          onHide={() => setShowDMTBank6Modal(false)}
          onSuccess={(data) => {
            console.log('DMT Bank6 transaction successful:', data);
            // Refresh balance after successful transaction
            refreshBalance();
            alert(`DMT Bank6 transaction successful! Reference ID: ${data.reference_id}`);
          }}
        />

        <AEPSOnboardingModal
          show={showAEPSOnboardingModal}
          onHide={() => setShowAEPSOnboardingModal(false)}
          onSuccess={(data) => {
            console.log('AEPS Onboarding successful:', data);
            alert(`AEPS Onboarding successful! Reference ID: ${data.reference_id}`);
          }}
        />

      <WalletMoneyModal
        show={showWalletMoneyModal}
        onHide={() => setShowWalletMoneyModal(false)}
        onSuccess={(data) => {
          console.log('Wallet Money transaction successful:', data);
          // Refresh balance after successful transaction
          refreshBalance();
          alert(`Wallet Money transaction successful! Reference ID: ${data.reference_id}`);
        }}
      />

      <AEPSModal
        show={showAEPSModal}
        onHide={() => setShowAEPSModal(false)}
        onSuccess={(data) => {
          console.log('AEPS transaction successful:', data);
          // Refresh balance after successful transaction
          refreshBalance();
          alert(`AEPS transaction successful! Transaction ID: ${data.transactionId}`);
        }}
      />

      <MicroATMModal
        show={showMicroATMModal}
        onHide={() => setShowMicroATMModal(false)}
        onSuccess={(data) => {
          console.log('Micro ATM transaction successful:', data);
          // Refresh balance after successful transaction
          refreshBalance();
          alert(`Micro ATM transaction successful! Transaction ID: ${data.transactionId}`);
        }}
      />

      <AEPSCashDepositModal
        show={showAEPSCashDepositModal}
        onHide={() => setShowAEPSCashDepositModal(false)}
        onSuccess={(data) => {
          console.log('AEPS cash deposit successful:', data);
          // Refresh balance after successful transaction
          refreshBalance();
          alert(`AEPS cash deposit successful! Transaction ID: ${data.transactionId}`);
        }}
      />

              <AccountOpeningModal
          show={showAccountOpeningModal}
          onHide={() => setShowAccountOpeningModal(false)}
          onSuccess={(data) => {
            console.log('Account opening application submitted:', data);
            alert(`Account opening application submitted! Reference: ${data.referenceNumber}`);
          }}
        />

        <VerificationsModal
          show={showVerificationsModal}
          onHide={() => setShowVerificationsModal(false)}
          onSuccess={(data) => {
            console.log('Verification completed:', data);
            alert(`Verification completed! Reference: ${data.reference}`);
          }}
        />

        <BillPaymentModal
          show={showBillPaymentModal}
          onHide={() => setShowBillPaymentModal(false)}
          onSuccess={(data) => {
            console.log('Bill payment successful:', data);
            // Refresh balance after successful transaction
            refreshBalance();
            alert(`Bill payment successful! Reference ID: ${data.reference_id}`);
          }}
        />

        <HLRModal
          show={showHLRModal}
          onHide={() => setShowHLRModal(false)}
          onSuccess={(data) => {
            console.log('HLR service completed:', data);
            alert(`HLR service completed successfully!`);
          }}
        />

        {/* BusBookingModal removed */}

        <KycUploadModal
          show={showKycUploadModal}
          onHide={() => setShowKycUploadModal(false)}
          onSuccess={(data) => {
            console.log('KYC document uploaded:', data);
            alert(`KYC document uploaded successfully!`);
          }}
        />

        {/* Inactivity Warning Popup */}
        <InactivityWarning 
          showWarning={showWarning}
          handleContinue={handleContinue}
          handleLogout={handleLogout}
        />
    </div>
  );
} 